<template>
    <v-dialog-old ref="dialog" id="step_one" @hidden="resetData" class="modalShadow_without-overflow">
        <ValidationObserver ref="stepOne">
            <form style="overflow:initial !important;">
                <drag-and-drop @fileDropped="filePrepare">
                    <fieldset style="min-height: 280px; overflow: unset;">
                        <legend>
                            Новый прайс-лист
                        </legend>
                        <template v-if="clinic_name === ''">
                            <ValidationProvider vid="clinics" name="Клиники сети" :rules="{required: clinic_name === ''}" v-slot="{ errors }">
                                <v-select
                                    :class="{ 'hasError': errors[0]}"
                                    v-tooltip.right="{
                                        content: errors[0],
                                        template: $errTemplate,
                                    }"
                                    v-on:remove="addClinic"
                                    :options="foundClinics"
                                    @search-change="findClinics"
                                    placeholder="Поиск клиник..."
                                >
                                    <template v-slot="{ option }">
                                      <div class="textarea">
                                          <span>{{ option.text }}</span>
                                          &nbsp;&nbsp;&nbsp;
                                          <span v-if="option.networkName !== null" class="label bg-red">
                                              {{ option.networkName }}
                                          </span>
                                          <br>
                                          <small>{{ option.cityName }}, {{ option.address }}</small>
                                      </div>
                                    </template>
                                </v-select>
                            </ValidationProvider>
                        </template>
                        <template v-else>
                            <label>Клиника</label>
                            <v-input v-model="clinic_name" disabled />
                        </template>
                        <div v-if="file.formData=== ''"  class="dropper-box"  >
                            <button class="button-add-file" @click.prevent="showFileChooser"><i class="far fa-folder-open" aria-hidden="true"/> Добавьте файл...</button>
                            <div id="dropZoneContainer">
                                <div>Перетяните файл сюда</div>
                            </div>
                        </div>
                        <div v-else>
                            <label>Файл</label>
                            <v-input v-model="file.name" disabled @clearData="clearFileData"/>
                        </div>
                    </fieldset>
                </drag-and-drop>
            </form>
        </ValidationObserver>

        <template v-slot:footer>
            <v-loading-component @click="stepUp">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: canStepUp && !btnDisabled}, loadingClass]" :disabled="btnDisabled">
                        Перейти к парсингу
                    </button>
                </template>
            </v-loading-component>
        </template>
        <input type="file"
               style="display: none"
               :accept="allowedTypes.join(',')"
               ref="uploadInput"
               @input="fileChoose"
        />
    </v-dialog-old>
</template>

<script>

import dragAndDrop from '@base/DragAndDrop.vue';
import StepOneTwoMixin from "@dialogs/pricelists/StepOneTwoMixin";
export default {
    components: {
        dragAndDrop
    },
    mixins: [StepOneTwoMixin],
    data: () => ({
        clinic_id: '',
        clinic_name: '',
        foundClinics: [],
        file: {
            name: '',
            formData: ''
        },
        btnDisabled: false,
    }),
    methods: {
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.resetData();
            this.$refs.dialog.hide();
        },
        resetData(){
            this.clinic_id = '';
            this.file = {
                name: '',
                formData: ''
            };
            this.clinic_name = '';
            this.foundClinics = [];
            this.btnDisabled = false;
        },
        stepUp(btn) {
            if(!this.canStepUp || this.btnDisabled){
                return;
            }
            this.btnDisabled = true;
            btn.startLoadingAnimation();
            this.axios.post('doctu/uploadAndCreatePricelistFile/' + this.clinic_id, this.file.formData)
                .then((response) => {
                    this.$emit('nextStep', response.data.id);
                }, () => {
                    this.btnDisabled = false;
                    btn.stopLoadingAnimation()
                });
        },
        addClinic: function (payload) {
            this.clinic_id = payload.id;
            this.clinic_name = payload.text;
            this.$nextTick(function () {
                this.$refs.stepOne.validate();
            });
        },
        findClinicByName: function (name) {
            return this.axios.post('/clinicsAutocomplete', {
                q: name,
                filter: {}
            });
        },
        findClinics: function (query) {
            if (query.length > 2) {
                this.findClinicByName(query).then(res => {
                    this.foundClinics = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.name,
                            cityName: item.data.cityName,
                            networkName: item.data.networkName,
                            address: item.data.address
                        }
                    })
                })
            } else {
                this.foundClinics = [];
            }
        },
    },

    computed: {
        canStepUp() {
            return this.file.formData !== '' && this.clinic_name !== ''
        }
    }
}
</script>

<style>
.dropper-box {
}
.button-add-file {
    width: 100%;
    height: 28px;
}
#step_one {
    width: 600px;
    height: 450px;
}
#dropZoneContainer {
    height: 186px;
    margin: auto;
    background: #f6f6f6;
    border: 2px dashed #eee;
    color: #515151;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
